import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { fetchAddress } from '../actions';
import { selectWork } from '../../Api/selectors';
import { IDW_ADDRESSES, REQUEST_ADDRESS } from '../constants';
import { Loader } from '../../../components/Loader';
import { selectAddress } from '../selectors';
import { VBox } from '../../../components/Box';
import { WithAddress } from './WithAddress';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';

const Container = styled.div``;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class AddressFieldsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get address() {
    return this.props.address || IDW_ADDRESSES.find(a => a.id == this.props.addressId);
  }

  get locale() {
    return this.props.locale;
  }

  render() {
    const address = this.address;
    console.log(address?.country?.name + 'address');
    return (
      <WithAddress addressId={this.props.addressId} key={this.props.addressId}>
        {address ? this.renderBody() : null}
      </WithAddress>
    );
  }

  renderBody() {
    const address = this.address;

    if (this.props.inlineshort) {
      return (
       <> <div>
          <span>{address.addressLine1} </span> 
          </div>
          <div><span style={{ fontWeight: 600 }}>{address.postcode} {address.city}  </span>
        </div>
        <div><span style={{ fontWeight: 600 }}> {address?.country?.name}  </span>
        </div>

       
        </>
      );
    }

    return (
      <Container>
        <div className="address">
          <div className="address-name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</div>
          <div className="lines">
            <div>{address.addressLine1}</div>
            <div>
              {address.postcode} {address.city}
            </div>
            <div>{translateCountry(address?.country?.name, this.locale)}</div>
          </div>
        </div>
      </Container>
    );
  }
}

AddressFieldsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    address: selectAddress(ownProps.addressId),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddressFields = compose(withConnect, withRouter)(AddressFieldsComp);
